import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import HealthClassSteps from "./HealthClassSteps";
import './HealthClassCalcButton.scss'

const white = "#ffffff";
const offWhite = "rgba(255, 255, 255, 0.7)";

const useStyles = makeStyles((theme) => ({
  buttonSelected: {
    borderColor: theme.palette.primary.main,
  },
  svgIcon: {
    '& > g': {
      stroke: theme.palette.primary.main,
    }
  },
  spanTip: {
    color: theme.palette.primary.main,
  },
  white: {
    color: white,
    border: `2px solid ${white}`,
    '&:hover': {
      color: offWhite,
      borderColor: offWhite
    },
    '&:focus': {
      boxShadow: `0 0 5px 0px ${offWhite}`,
      outline: 'none'
    }
  }
}));

export default function HealthClassAnalysis(props) {
  function handleClick() {
    props.fields.setModalHealthCalcIsOpen(false);
  }

  return (
    <React.Fragment>
      <HealthClassAnalysis.ModalHeroImageHeader
        onButtonClick={() => handleClick()}
        healthClassRatingLabel={props.currentHealthClass}
      />
      <div className="modal-scroll p-0">
        <HealthClassSteps
          setModalHealthCalcIsOpen={props.fields.setModalHealthCalcIsOpen}
          onHealthClassChange={props.onHealthClassChange}
        />
      </div>
    </React.Fragment>
  )
}

HealthClassAnalysis.ModalHeroImageHeader = function (props) {

  useStyles();

  const healthClass = props.healthClassRatingLabel || 'Good Health';

  return (
    <Modal.Header closeButton>
      <div className="healthRatingImageHeader">
        <div className="healthRatingHeroImage"></div>
        <div className="headerModalDiv">
          <p>My Health Rating</p>
          <p id="faceTotal">
            {healthClass}
          </p>
        </div>
      </div>
    </Modal.Header>
  )
}





// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/HealthClassCalculator/HealthClassAnalysis.js